import { rememberQrDeepLinkPath, resolveAppDeepLinkPath } from '@/lib/checklist-qr';
import { useNotificationNavigationStore } from '@/lib/store';

export function applyNativeDeepLinkUrl(url: string): string | null {
  const path = resolveAppDeepLinkPath(url);
  if (!path) return null;
  rememberQrDeepLinkPath(path);
  useNotificationNavigationStore.getState().setPendingPath(path);
  return path;
}

export async function bindNativeDeepLinkListeners(): Promise<{ remove: () => Promise<void> } | null> {
  try {
    const { App } = await import('@capacitor/app');
    const listener = await App.addListener('appUrlOpen', (event) => {
      const url = event?.url;
      if (!url || typeof url !== 'string') return;
      applyNativeDeepLinkUrl(url);
    });
    const launch = await App.getLaunchUrl();
    const url = launch?.url;
    if (url && typeof url === 'string') {
      applyNativeDeepLinkUrl(url);
    }
    return listener;
  } catch {
    return null;
  }
}
